'use client'

import PropTypes from 'prop-types'

import { dateIsInThePast, dateIsToday, dateIsTomorrow, formatDate, parseDate } from '@repo/utils/time'
import { DateSeparator } from '@repo/ui/DateSeparator'

export const ComingUpDateSeparator = ({ title, sx }) => {
  const parsedDate = parseDate(title)
  let dateToDisplay = formatDate(parsedDate, 'EEE d MMM')
  if (dateIsInThePast(title, 'yyyyMMdd')) dateToDisplay = 'Overdue'
  else if (dateIsToday(title, 'yyyyMMdd')) dateToDisplay = 'Today'
  else if (dateIsTomorrow(title, 'yyyyMMdd')) dateToDisplay = 'Tomorrow'

  let textColor = 'text.primary'
  if (dateToDisplay === 'Overdue') textColor = 'error.main'
  if (dateToDisplay === 'Today') textColor = 'warning.light'

  return (
    <div data-testid="ComingUpDateSeparator">
      <DateSeparator dateToDisplay={dateToDisplay} textColor={textColor} sx={sx} />
    </div>
  )
}

ComingUpDateSeparator.propTypes = {
  title: PropTypes.string,
  sx: PropTypes.object
}
